import { overriddenComponents } from "./mapping";
import { overrideStore } from "react-overridable";
for (const [key, value] of Object.entries(overriddenComponents)) {
  overrideStore.add(key, value);
}
